import { render, staticRenderFns } from "./ModeDefault.vue?vue&type=template&id=6dd20d4a&scoped=true&lang=pug&"
import script from "./ModeDefault.vue?vue&type=script&lang=ts&"
export * from "./ModeDefault.vue?vue&type=script&lang=ts&"
import style0 from "./ModeDefault.vue?vue&type=style&index=0&id=6dd20d4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd20d4a",
  null
  
)

export default component.exports